import React, { useState } from "react";
import { Link, useLocation, useHistory } from "react-router-dom";
import Logo from "../assets/Logo.svg";
import styles from "./PublicLayout.module.css";
import { OutlinedButton, ContainedButton } from "../components/Main/Landing/components/buttons/Buttons";
import FooterCommon from "./FooterCommon";

type PublicLayoutProps = {
  children: React.ReactNode;
};

const NAV_LINKS = [
  { label: "Discover", href: "/discover" },
  { label: "The Vault", href: "/the-vault" },
  { label: "Genesis Collection", href: "/genesis-collection" },
  { label: "Join Our Newsletter", href: "/newsletter" },
];

export default function PublicLayout({ children }: PublicLayoutProps) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  const history = useHistory();

  return (
    <div className={styles.wrapper}>
      {/* ── Header ── */}
      <header className={styles.header}>
        <div className={styles.headerInner}>
          {/* Logo */}
          <Link to="/" className={styles.logoLink} id="public-nav-logo">
            <img src={Logo} alt="SugarCribs" className={styles.logo} />
          </Link>

          {/* Desktop Nav */}
          <nav className={styles.nav} aria-label="Main navigation">
            {NAV_LINKS.map(link => (
              <Link
                key={link.label}
                to={link.href}
                className={`${styles.navLink} ${location.pathname === link.href ? styles.navLinkActive : ""
                  }`}
                id={`public-nav-${link.label.toLowerCase().replace(/\s+/g, "-")}`}
              >
                {link.label}
              </Link>
            ))}
          </nav>

          {/* CTA Buttons */}
          <div className={styles.headerCtas}>
            <OutlinedButton text="Login" styles={`${styles.roundedBtn} ${styles.loginCustom}`} onClick={() => history.push("/login")} />
            <ContainedButton text="Apply as Creator" styles={`${styles.roundedBtn} ${styles.loginCustom} ${styles.hideOnMobile}`} onClick={() => history.push("/apply-as-creator")} />
          </div>

          {/* Mobile hamburger */}
          <button
            className={styles.hamburger}
            onClick={() => setMobileMenuOpen(prev => !prev)}
            aria-label="Toggle menu"
            id="public-nav-hamburger"
          >
            <span className={`${styles.hamburgerLine} ${mobileMenuOpen ? styles.open : ""}`} />
            <span className={`${styles.hamburgerLine} ${mobileMenuOpen ? styles.open : ""}`} />
            <span className={`${styles.hamburgerLine} ${mobileMenuOpen ? styles.open : ""}`} />
          </button>
        </div>

        {/* Mobile Drawer */}
        {mobileMenuOpen && (
          <div className={styles.mobileMenu}>
            {NAV_LINKS.map(link => (
              <Link
                key={link.label}
                to={link.href}
                className={styles.mobileNavLink}
                onClick={() => setMobileMenuOpen(false)}
              >
                {link.label}
              </Link>
            ))}
            <div className={styles.mobileCtas}>
              <ContainedButton
                text="Apply as Creator"
                styles={styles.roundedBtn}
                onClick={() => {
                  setMobileMenuOpen(false);
                  history.push("/apply-as-creator");
                }}
              />
            </div>
          </div>
        )}
      </header>

      {/* ── Page Content ── */}
      <main className={styles.content}>{children}</main>

      {/* ── Footer ── */}
      <FooterCommon />
    </div>
  );
}
